import { Button, Spin } from 'antd';
import { EyeOutlined, CheckCircleOutlined, ExclamationCircleOutlined, ClockCircleOutlined, ReloadOutlined } from '@ant-design/icons';

import fileSvg from 'assets/images/file.svg';
import deleteSvg from 'assets/images/delete.svg';
import { TaskState } from '../../../../../../gql/graphql';
import { File } from '../../../../../../utils/interfaces/file.interface';

type UploadStatus = 'pending' | 'uploading' | 'success' | 'error';

interface InputUploadedFileProps {
  file: File;
  seeFile?: Function;
  deleteFile?: Function;
  loadingDeleteFile?: boolean;
  icon?: string;
  state?: TaskState | undefined;
  isActionSeeFile?: boolean;
  uploadStatus?: UploadStatus;
  errorMessage?: string;
  onRetry?: Function;
}

const InputUploadedFile = ({
  file,
  seeFile,
  deleteFile,
  loadingDeleteFile,
  icon,
  state,
  isActionSeeFile,
  uploadStatus,
  errorMessage,
  onRetry
}: InputUploadedFileProps) => {
  const _seeFile = (file: File) => window.open(`${file.url}?preview=true&app=processing`, '_blank');

  // Renderizar icono según estado de upload
  const renderUploadStatusIcon = () => {
    if (!uploadStatus) return null;

    switch (uploadStatus) {
      case 'pending':
        return <ClockCircleOutlined style={{ color: '#8c8c8c', fontSize: 16 }} />;
      case 'uploading':
        return <Spin size="small" />;
      case 'success':
        return <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 16 }} />;
      case 'error':
        return <ExclamationCircleOutlined style={{ color: '#ff4d4f', fontSize: 16 }} />;
      default:
        return null;
    }
  };

  return (
    <div className="InputUploadedFile">
      <div className="file-ok">
        <div className="file" style={{ paddingLeft: icon ? 7 : 0 }}>
          {icon && (
            <div className="circle-input">
              <img src={icon} alt="upload" className="upload" />
            </div>
          )}
          <div className={`file-content file-content-${state}`}>
            <div className="flex-btw">
              <div className="file-name">
                <img className="fileIcon" alt="fileIcon" src={fileSvg} />
                <span className="name">{file?.name}</span>
              </div>
              <div className="content-buttons">
                {uploadStatus && (
                  <span style={{ marginLeft: 8 }}>
                    {renderUploadStatusIcon()}
                  </span>
                )}
                {seeFile && (
                  <Button
                    className="button button-transparent"
                    onClick={() => seeFile(file)}
                  >
                    <EyeOutlined />
                  </Button>
                )}
                {isActionSeeFile && (
                  <Button
                    className="button button-transparent"
                    onClick={() => _seeFile(file)}
                  >
                    <EyeOutlined />
                  </Button>
                )}
                {uploadStatus === 'error' && onRetry && (
                  <Button
                    className="button button-transparent"
                    onClick={() => onRetry()}
                    title="Retry upload"
                  >
                    <ReloadOutlined style={{ color: '#ff4d4f' }} />
                  </Button>
                )}
                {deleteFile && !uploadStatus && (
                  <Button
                    className="button button-transparent"
                    loading={loadingDeleteFile}
                    onClick={() => deleteFile(file)}
                    disabled={loadingDeleteFile}
                  >
                    <img
                      src={deleteSvg}
                      alt="delete"
                      className="delete"
                      width="15"
                    />
                  </Button>
                )}
              </div>
            </div>
            {/*{uploadStatus === 'error' && errorMessage && (
              <div style={{ marginTop: 4, color: '#ff4d4f', fontSize: 12 }}>
                {errorMessage}
              </div>
            )}*/}
          </div>
        </div>
      </div>
    </div>
  );
};
export default InputUploadedFile;
